<template>
    <inter-table
            :showFilters="true"
            :fields="fields"
            action="notices"
    >
        <template v-slot:cell(date)="data">
            <div class="mb-2">
                <span class="text-success">{{data.item.start_date | date}}</span>
            </div>
            <div>
                <span class="text-danger">{{data.item.expire_date | date}}</span>
            </div>
        </template>

        <template v-slot:cell(level)="data">
            <b-badge :variant="data.item.level" class="px-2 text-uppercase">
                {{data.item.level}}
            </b-badge>
        </template>

        <template v-slot:cell(title)="data">
            <div class="text-uppercase">{{data.item.title}}</div>
        </template>

        <template v-slot:cell(text)="data">
            <div v-html="data.item.text"></div>
        </template>

        <template v-slot:cell(recipient)="data">
            <div v-if="data.item.sent_to_all">
                <b-badge variant="primary" class="px-2 text-uppercase">
                    inviato a tutti
                </b-badge>
            </div>
            <div v-else>
                <div v-if="data.item.users.length === 1">
                    <div class="text-uppercase text-primary">{{data.item.users[0].data.society}}</div>
                    <div class="small">{{data.item.users[0].email}}</div>
                </div>
                <div v-else>
                    {{data.item.users.length}} Destinatari
                </div>
            </div>
        </template>

    </inter-table>
</template>

<script>
    import InterTable from "../../../components/table/InterTable";

    export default {
        name: "AdminNoticesTable",
        components: {InterTable},
        data() {
            return {

                fields: [
                    {key: 'title', label: 'Titolo', class: 'text-left'},
                    {key: 'text', label: 'Testo', class: 'text-left'},
                    {key: 'date', label: 'Intervallo', class: 'text-center'},
                    {key: 'level', label: 'Livello', class: 'text-center'},
                    {key: 'recipient', label: 'Destinatari', class: 'text-left'},
                    {key: 'action', label: ''},
                ]
            }
        },
    }
</script>

<style scoped>

</style>
